import React from "react"
import { CarouselComponent } from "./CarouselComponent"

export const WelcomeComponent = () => {
  return (
    <CarouselComponent images={["/images/default_landing_desktop.jpg"]}>
      <div className="row">
        <div className="col mx-auto">
          <h1 className="text-center">Welcome to the Redemption Center.<br />Ready to get started?</h1>
        </div>
      </div>
    </CarouselComponent>
  )
}
